import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  containerDark: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(6, 8)
  },
  container: {
    width: '100%',
    marginBottom: 0
  },
  mortgagesContainer: {
    padding: theme.spacing(0, 6, 3, 8),
    paddingTop: 0,
    backgroundColor: theme.colors.card_background_primary_editable,
    borderTop: `1px solid ${theme.onCardDivider.white}`,
    width: '100%',
    // Reskin: the card body is already white; a square fill here clips the card's rounded corners.
    ...reskinStyles(theme, { backgroundColor: 'transparent' })
  },
  leftItem: {
    paddingRight: theme.spacing(5)
  },
  rightItem: {
    paddingLeft: theme.spacing(5)
  },
  streetMapText: {
    color: `${theme.colors.action_text} !important`,
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 12,
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  sqFtErrorSpacing: {
    marginBottom: 70
  },
  notification: {
    margin: 0,
    boxShadow: 'none',
    textAlign: 'start',
    '& img': {
      marginLeft: 0
    }
  },
  rceValues: {
    columnGap: theme.spacing(1)
  },
  rceEditButton: {
    padding: 0
  },
  rceEditIcon: {
    height: 20,
    width: 20
  },
  rceOurValue: {
    gap: theme.spacing(1),
    alignItems: 'center'
  },
  coverageAmount: {
    marginTop: 6
  },
  notificationText: {
    display: 'flex',
    direction: 'column',
    paddingLeft: theme.spacing(8),
    paddingTop: theme.spacing(2),
    fontSize: 12,
    fontWeight: 400
  },
  buttonContainer: {
    alignItems: 'center'
  },
  iconStyle: {
    height: 24,
    width: 24,
    marginRight: theme.spacing(1)
  },
  cardStyling: {
    boxShadow: 'none',
    // marginTop 0 is to override some other margin making the card be too close
    marginTop: 0,
    marginBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    color: theme.colorPalette.green_100,
    fontSize: 12
  },
  button: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: 12,
    borderRadius: 0,
    paddingLeft: theme.spacing(0)
  },
  // external link styles
  streetMapLink: {
    color: theme.colors.action_text,
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 14,
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(2)
  },
  linkAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  }
}));

export default useStyles;
